import React, { Component, Suspense } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import instance from "../../../store/actions/instance";
import moment from "moment";

// Antd Components
import { Modal, message, Button } from "antd";
import { LoadingOutlined, CarOutlined } from "@ant-design/icons";

// Actions

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

class InvoiceModal extends Component {
  state = {
    loading: false,
    orderDetails: null,
  };
  componentDidMount = () => {
    this.setState({ loading: true });

    const { selectedOrder, config, t } = this.props;

    const type =
      selectedOrder.invoice_details.type === "Promise" ? "promise" : "order";
    this.fetchOrderDetails(type, selectedOrder.invoice_details.id);
  };
  fetchOrderDetails = async (type, id) => {
    const { t } = this.props;
    try {
      const res = await instance.get(`/get_order_details/${type}/${id}/`);

      this.setState({ orderDetails: res.data, loading: false });
    } catch (err) {
      if (err.response.status == 403) message.error(t("AccessDeniedMessage"));
    }
  };
  render() {
    const { t, config, settings, selectedOrder, visible, permissions } =
      this.props;
    const orderDetails = this.state.orderDetails;
    if (!selectedOrder) return null;

    const order = selectedOrder.invoice_details;

    const currency =
      config.language == "arabic"
        ? settings.currency_local
        : settings.currency_english;

    const normalizedCountryName = (order.area?.country_name || "")
      .replace(/[\u200B-\u200F\u202A-\u202E\u2060\uFEFF]/g, "")
      .trim()
      .toLowerCase();
    const isQatar = normalizedCountryName === "qatar";
    const isEgypt = normalizedCountryName === "egypt";
    const areaText = isQatar ? "District" : "Area";
    const copyToClipboard = () => {
      const textField = document.createElement("textarea");
      textField.innerText = `https://${this.props.domain}/invoice/${selectedOrder.order}/`;
      document.body.appendChild(textField);
      textField.select();
      document.execCommand("copy");
      textField.remove();
      message.success(t("Invoice link copied successfully"));
    };
    order.customer = [`${order.first_name} ${order.last_name}`, order.phone];

    const translateStartEnd = (str) => {
      if (config.language != "arabic") return str;
      return str
        .replace("AM", "ص")
        .replace("AM", "ص")
        .replace("PM", "م")
        .replace("PM", "م")
        .replace("to", "الى");
    };

    return (
      <Modal
        style={{ top: 20 }}
        title={
          <div
            className="ant-modal-title"
            style={{
              textAlign: config.direction == "rtl" ? "right" : "left",
            }}
          >
            {`${t("Inovice")}`}
          </div>
        }
        visible={visible}
        onCancel={() => this.props.onClose()}
        cancelText={t("Close")}
        bodyStyle={{
          paddingTop: 0,
          width: "auto",
          padding: "0px 18px",
          textAlign: config.direction == "ltr" ? "left" : "right",
        }}
        footer={[
          <Button key="back" onClick={() => this.props.onClose()}>
            {t("Close")}
          </Button>,
        ]}
      >
        <div
          className="jumbotron bg-white p-0 mt-3 "
          style={{ paddingTop: 20, minWidth: 320 }}
        >
          <div style={{ marginBottom: 12 }}>
            {order.has_downloadables && (
              <Button
                size="small"
                className={config.direction == "ltr" ? "mr-1" : "ml-1"}
              >
                <a
                  href={`https://${this.props.domain}/download/${selectedOrder.order}`}
                  target="_blank"
                >
                  {t("Downloads page")}
                </a>
              </Button>
            )}

            {settings.enable_invoicing && permissions.can_copy_link_orders && (
              <>
                <Button
                  size="small"
                  className={config.direction == "ltr" ? "mr-1" : "ml-1"}
                  onClick={() => copyToClipboard()}
                >
                  {t("Copy link")}
                </Button>
                <Button
                  size="small"
                  className={config.direction == "ltr" ? "mr-1" : "ml-1"}
                >
                  <a
                    href={`https://wa.me/${order.customer[1].slice(
                      1
                    )}?text=Hello ${
                      order.customer ? order.customer[0] : ""
                    }, here is an invoice for your order ${
                      order.tracking_id
                    }. Thank you. https://${this.props.domain}/invoice/${
                      order.tracking_id
                    }/`}
                    target="_blank"
                  >
                    {t("Whatsapp")}
                  </a>
                </Button>
              </>
            )}
          </div>
          <h5>{t("Invoice")}</h5>

          <p className="text-muted" style={{ lineHeight: 1.3 }}>
            {t("Tracking Code")}: {order.tracking_id}
          </p>

          <p className="m-0">
            {t("Placed")}: {moment(order.placed).format("MMM Do YYYY - h:mm a")}
          </p>
          <p className="m-0">
            {t("ReceivedInvoice")}:{" "}
            {order.received
              ? moment(order.received).format("MMM Do YYYY - h:mm a")
              : "-"}
          </p>
          {order.expected_delivery_date &&
          order.expected_delivery_slot_start &&
          order.expected_delivery_slot_end ? (
            <p className="m-0">
              {t("Expected Delivery")}:{" "}
              {`${moment(order.expected_delivery_date).format(
                "MMM Do, YYYY"
              )} (${moment(
                order.expected_delivery_slot_start,
                "HH:mm:ss"
              ).format("h:mm a")} - ${moment(
                order.expected_delivery_slot_end,
                "HH:mm:ss"
              ).format("h:mm a")})`}
            </p>
          ) : null}
          <h5 className="mt-3">
            {order.is_delivery ? t("Deliver to") : t("Pickup Address")}
          </h5>
          <p className="my-0">
            {t("Customer")}: {order.first_name} {order.last_name} (
            {order.phone.startsWith("+965")
              ? `${order.phone.slice(0, 4)}-${order.phone.slice(4)}`
              : order.phone}
            )
          </p>
          <p>
            {order.is_delivery && (
              <>
                {t("Country")}: {t(order.area.country_name)}
                &nbsp;&nbsp;&nbsp;&nbsp;
              </>
            )}

            {(order.area != "-" || order.pickup_address) && (
              <>
                {order.is_delivery ? t(areaText) : t("PickupFrom")}:{" "}
                {config.language == "arabic"
                  ? order.area.ar_name
                  : order.area.name}
                {order.is_delivery &&
                isEgypt &&
                order.address.block &&
                order.address.block !== "-"
                  ? `, ${order.address.block}`
                  : ""}
              </>
            )}
            {!order.is_delivery && order.pickup_address && (
              <>
                <p className="mt-2 mb-1">
                  <CarOutlined />
                  <span className="mx-2">{t("Car details")}:</span>
                </p>
                <div className="mx-3">
                  {order.car_make && (
                    <p className="m-0">
                      {t("Make")}: {order.car_make}
                    </p>
                  )}
                  {order.car_color && (
                    <p className="m-0">
                      {t("Color")}: {order.car_color}
                    </p>
                  )}
                  {order.car_plate_number && (
                    <p className="m-0">
                      {t("Plate number")}: {order.car_plate_number}
                    </p>
                  )}{" "}
                  {!order.car_make &&
                  !order.car_color &&
                  !order.car_plate_number ? (
                    <p>{t("Car details were not provided")}</p>
                  ) : (
                    ""
                  )}
                </div>
              </>
            )}
            {order.is_delivery && (
              <>
                {order.address.block && !isQatar && !isEgypt ? (
                  <>
                    &nbsp;&nbsp;&nbsp;&nbsp;{t("Block")}: {order.address.block}
                  </>
                ) : (
                  ""
                )}
                {order.address.zone && isQatar ? (
                  <>
                    &nbsp;&nbsp;&nbsp;&nbsp;{t("Zone")}: {order.address.zone}
                  </>
                ) : (
                  ""
                )}
                {order.address.street ? (
                  <>
                    &nbsp;&nbsp;&nbsp;&nbsp;{t("Street")}:{" "}
                    {order.address.street}
                  </>
                ) : (
                  ""
                )}
                {order.address.building ? (
                  <>
                    &nbsp;&nbsp;&nbsp;&nbsp;{t("Building")}:{" "}
                    {order.address.building}
                  </>
                ) : (
                  ""
                )}
                {order.address.avenue && !isEgypt ? (
                  <>
                    &nbsp;&nbsp;&nbsp;&nbsp;{t("Avenue")}:{" "}
                    {order.address.avenue}
                  </>
                ) : (
                  ""
                )}
                {order.address.floor ? (
                  <>
                    &nbsp;&nbsp;&nbsp;&nbsp;{t("Floor")}: {order.address.floor}
                  </>
                ) : (
                  ""
                )}
                {order.address.apartment ? (
                  <>
                    &nbsp;&nbsp;&nbsp;&nbsp;{t("Apartment")}:{" "}
                    {order.address.apartment}
                  </>
                ) : (
                  ""
                )}
                {order.address.location_id &&
                order.area.country_name == "Kuwait" ? (
                  <>
                    &nbsp;&nbsp;&nbsp;&nbsp;{t("PACI")}:{" "}
                    {order.address.location_id}
                  </>
                ) : (
                  ""
                )}

                {order.address.additional ? (
                  <>
                    &nbsp;&nbsp;&nbsp;&nbsp;{t("Additional")}:{" "}
                    {order.address.additional}
                  </>
                ) : (
                  ""
                )}
              </>
            )}
          </p>

          {orderDetails ? (
            <>
              <div className="row">
                <div className="col-xs-12 col-12">
                  <h5>{t("Your Order")}:</h5>
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th scope="col">{t("ProductInvoiceTable")}</th>
                        <th
                          scope="col"
                          style={{ display: order.hide_price && "none" }}
                        >
                          {t("PriceInvoiceTable")}
                        </th>
                        <th scope="col">{t("QuantityInvoiceTable")}</th>
                        <th scope="col">{t("TotalsInvoiceTable")}</th>
                      </tr>
                    </thead>
                    <tbody id="invoice-products">
                      {orderDetails.items.map((item) => (
                        <>
                          <tr style={{ display: order.hide_price && "none" }}>
                            <td>
                              <strong>
                                {config.language == "arabic"
                                  ? item.name_ar
                                  : item.name}{" "}
                                {item.type_of_product == "bookable" ? (
                                  <>
                                    <br />
                                    <small>
                                      booked for: {item.booking_date}{" "}
                                      {item.booking_is_all_day
                                        ? "- all day"
                                        : `${item.booking_start} - ${item.booking_end}`}
                                    </small>
                                  </>
                                ) : null}
                                {item.type_of_product == "service" ? (
                                  <span style={{ direction: config.direction }}>
                                    <br />
                                    <small>
                                      {t("Booked for")}: {item.booking_date}{" "}
                                      {`(${translateStartEnd(
                                        `${moment(
                                          item.booking_start,
                                          "HH:mm:ss"
                                        ).format("h:mm A")} - ${moment(
                                          item.booking_end,
                                          "HH:mm:ss"
                                        ).format("h:mm A")}`
                                      )})`}
                                    </small>
                                    <br />
                                    <span>
                                      {t("With")}:{" "}
                                      {config.language == "arabic"
                                        ? item.resource.ar_name ||
                                          item.resource.name
                                        : item.resource.name}
                                    </span>
                                  </span>
                                ) : null}
                                {item.special_remarks ? (
                                  <>
                                    <br />
                                    <small>
                                      remarks: {item.special_remarks}
                                    </small>
                                  </>
                                ) : null}
                              </strong>
                            </td>
                            <td>
                              <strong>
                                {item.price.toFixed(settings.currency_decimals)}{" "}
                                {t(currency)}
                              </strong>
                            </td>
                            <td>
                              <strong>x {item.quantity}</strong>
                            </td>
                            <td>
                              <strong>
                                {" "}
                                {(
                                  parseInt(item.quantity) *
                                  parseFloat(item.price)
                                ).toFixed(settings.currency_decimals)}{" "}
                                {t(currency)}
                              </strong>
                            </td>
                          </tr>
                          {item.options.map((option) => (
                            <tr style={{ display: order.hide_price && "none" }}>
                              <td
                                className={
                                  config.direction == "ltr" ? "pl-5" : "pr-5"
                                }
                              >
                                {config.language == "arabic"
                                  ? option.product_option.ar_value
                                  : option.product_option.value}
                              </td>
                              <td>
                                {option.price.toFixed(
                                  settings.currency_decimals
                                )}
                              </td>
                              <td>x {option.quantity}</td>
                              <td>
                                {(
                                  parseInt(option.quantity) *
                                  parseFloat(option.price)
                                ).toFixed(settings.currency_decimals)}{" "}
                                {t(currency)}
                              </td>
                            </tr>
                          ))}
                        </>
                      ))}
                      {orderDetails.discounts.length
                        ? orderDetails.discounts.map((ord) => (
                            <tr>
                              <td>{ord.description}</td>
                              <td></td>
                              <td></td>
                              <td
                                style={{ display: order.hide_price && "none" }}
                              >
                                -{" "}
                                {ord.value.toFixed(settings.currency_decimals)}{" "}
                                {t(currency)}
                              </td>
                            </tr>
                          ))
                        : null}
                      {order.is_delivery && (
                        <tr style={{ display: order.hide_price && "none" }}>
                          <td>{t("Delivery")}</td>
                          <td></td>
                          <td></td>
                          <td>
                            {order.delivery_rate.toFixed(
                              settings.currency_decimals
                            )}{" "}
                            {t(currency)}
                          </td>
                        </tr>
                      )}
                      {order.vat_rate > 0 && (
                        <tr style={{ display: order.hide_price && "none" }}>
                          <td>{t("VAT")}</td>
                          <td></td>
                          <td></td>
                          <td>
                            {(
                              (orderDetails.total * order.vat_rate) /
                              (1 + order.vat_rate)
                            ).toFixed(settings.currency_decimals)}{" "}
                            {t(currency)}
                          </td>
                        </tr>
                      )}

                      {order.additional_fee > 0 && (
                        <tr style={{ display: order.hide_price && "none" }}>
                          <td>
                            {settings.enable_table_qr
                              ? t("Tip")
                              : t("Additional fee")}
                          </td>
                          <td></td>
                          <td></td>
                          <td>
                            {order.additional_fee.toFixed(
                              settings.currency_decimals
                            )}{" "}
                            {t(currency)}
                          </td>
                        </tr>
                      )}
                      <tr style={{ display: order.hide_price && "none" }}>
                        <td>{t("TotalsInvoiceTable")}</td>
                        <td></td>
                        <td></td>
                        <td style={{ display: order.hide_price && "none" }}>
                          {orderDetails.total.toFixed(
                            settings.currency_decimals
                          )}{" "}
                          {t(currency)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              {order.special_remarks ? (
                <>
                  <h6>Special remarks:</h6>
                  <p>{order.special_remarks}</p>
                </>
              ) : null}
              {order.is_gift ? (
                <>
                  <h6>Gift details:</h6>
                  <p className="mb-0">Message: {order.gift_message}</p>
                  <p className="mb-0">Name: {order.gift_recipient_name}</p>
                  <p className="mb-0">Phone: {order.gift_recipient_number}</p>
                  <p className="mb-0">
                    Address: {order.gift_recipient_address}
                  </p>
                </>
              ) : null}
            </>
          ) : (
            "Loading..."
          )}
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    config: state.config,
    permissions: state.auth.permissions,
    settings: state.auth.settings,
    domain: state.auth.settings.domain,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {};
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces()(InvoiceModal));
